import { updateAbilityWithRole } from '../../permissions/rules'

export default (store) => {
  const user = store.getters['user/getUser'] || {}
  updateAbilityWithRole(user)

  return store.subscribe((mutation) => {
    switch (mutation.type) {
      case 'user/LOGIN_USER':
        const user = mutation.payload
        updateAbilityWithRole(user)
        break

      case 'user/LOGOUT_USER':
        updateAbilityWithRole()
        break
    }
  })
}
